import { render, staticRenderFns } from "./SubGroupEngagement.vue?vue&type=template&id=516fa80e"
import script from "./SubGroupEngagement.vue?vue&type=script&lang=js"
export * from "./SubGroupEngagement.vue?vue&type=script&lang=js"
import style0 from "./SubGroupEngagement.vue?vue&type=style&index=0&id=516fa80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports